/**
 * Generado por nosotros, basandonos en componentes de ADF 5.0.0
 */

import { Component, inject, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { SearchQueryBuilderService, SearchWidget, SearchWidgetSettings } from '@alfresco/adf-content-services';
import { KeyValue } from '@angular/common';
import { FormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TranslationService } from '@alfresco/adf-core';

@Component({
    selector: 'smt-search-boolean',
    templateUrl: './search-boolean.component.html',
    styleUrls: ['./search-boolean.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'smt-search-boolean' }
})
export class SMTSearchBooleanComponent implements SearchWidget, OnInit, OnDestroy{
    
    /** The content of the text box. */
    @Input()
    value: KeyValue<string, string>;

    id: string;
    settings?: SearchWidgetSettings;
    context?: SearchQueryBuilderService;
    options: KeyValue<string, string>[];
    startValue: string;
    displayValue$: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);

    select: UntypedFormControl;
    form: UntypedFormGroup;
    private _formBuilder = inject(FormBuilder);
    filteredOptions: Observable<KeyValue<string, string>[]>;
    query: string;
    editable: boolean;

    private onDestroy$ = new Subject<boolean>();
    
    constructor(private translationService: TranslationService) {
        this.form =  this._formBuilder.group({
            "select": [[]]
       }); 
       this.editable = true;
    }

    ngOnInit(): void {
        //Mirar si tienes textos personalizados para true y false en el settings
        const trueText = this.settings?.trueText ? this.settings.trueText : 'ALDEN.CUSTOM_LISTS.FILTERS.BOOLEAN_TRUE_TEXT';
        const falseText = this.settings?.falseText ? this.settings.falseText : 'ALDEN.CUSTOM_LISTS.FILTERS.BOOLEAN_FALSE_TEXT';

        this.options = [
            { key: 'true', value: this.translationService.instant(trueText)}, 
            { key: 'false', value: this.translationService.instant(falseText)}
        ];

        if (this.settings) {
            if (this.settings.options && this.settings.options.length > 0) {
              this.options = this.settings.options;
            }

            if(this.settings.allowUpdateOnChange !== undefined && this.settings.allowUpdateOnChange !== null) {
                this.editable = this.settings.allowUpdateOnChange;
            }
        }
    }
    
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    hasValidValue() {
        return !!this.value;
    }

    getCurrentValue() {
        return this.value.key;
    }

    getAppliedValue(): any {
        return this.value;
    }

    submitValues() {
       this.updateQuery();
       this.updateDisplayValue();
    }

    reset() {
        if(this.form.get('select').value){
            this.form.get('select').reset();
        }
        this.value = null;
        this.updateQuery();
        this.updateDisplayValue();
    }

    updateDisplayValue(): void {
        if (this.form.invalid || !this.value) {
            this.displayValue$.next(null);
        } else {
            const maxLength = 25;
            const value = this.value.value;
            this.displayValue$.next({
                    value: value.substring(0, maxLength) + (value.length > maxLength ? '...' : ''),
                    tooltip: value
            });
        }
    }

    updateQuery() {
        this.value = this.form.get('select').value;
        if (this.id && this.context && this.settings && this.settings.field) {
            this.query = '';
            if(this.value){
                /**Legacy para types viejos */
                if(this.settings.aspectField){
                    this.query = this.value.key === 'true' ? `+ASPECT:'${this.settings.field}'` : `-ASPECT:'${this.settings.field}'`;
                    this.context.queryFragments[this.id] = this.query;
                }else{
                    this.query = `+@${this.settings.field}:'${this.value.key}'`;
                    this.context.queryFragments[this.id] = this.query;
                }
            }
        }
        if(this.context) {
            this.context.queryFragments[this.id] = this.query;
            this.context.update();
        }
    }

    //Custom SMT
    getCurrentQuery() {
        return this.query;
    }

    setValue(value: KeyValue<string, string>) {
        if(value === undefined) this.reset();
        else this.value = value;
    }

    disable() {
        this.editable = false;
        this.form.get('select').disable();
    }

    enable() {
        this.editable = true;
        this.form.get('select').enable();
    }
}
